import React from "react";
import { CFormSelect } from "@coreui/react";

const Select = (props) => {
  return <CFormSelect {...props} {...props.input} />;
};

export default Select;
